import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './TrafficUsageIndicator.module.css';

const bindClasses = classNameBind.bind(styles);
const orangeIndicator = () => <div className={bindClasses('orange-indicator')} />;
const redIndicator = () => <div className={bindClasses('red-indicator')} />;

const TrafficUsageIndicator = ({
  status,
}) => {
  if (status === 'none') {
    return null;
  }

  return (
    <div
      data-ppuc-id={`TrafficUsageIndicator.${status}`}
      className={bindClasses('traffic-indicator')}
    >
      {status === 'warning' ? orangeIndicator() : redIndicator()}
    </div>
  );
};

export { TrafficUsageIndicator };
